import React from "react";

const formatter = new Intl.NumberFormat("en-US");

export default function Count({ children, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span {...props} className="text-xs px-1.5 py-0.5 bg-gray-300 rounded-sm tabular-nums">
      {Number.isInteger(children) ? formatter.format(children as number) : children}
    </span>
  );
}
